// extracted by mini-css-extract-plugin
export default {"signup_form":"Login_signup_form__3uZ15"};